import PropTypes from 'prop-types'

import { userDetailsPropType } from '../../users/prop-types'

import unknownWordCorrectionPropType from './unknown-word-correction-prop-type'

const unknownWordPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  menuCurationTaskId: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  originalValue: PropTypes.string,
  context: PropTypes.string,
  payload: PropTypes.string,
  dietId: PropTypes.string,
  allergenId: PropTypes.string,
  ingredientId: PropTypes.string,
  languageId: PropTypes.string,
  ingredientKeywordMatchType: PropTypes.string,
  posIndex: PropTypes.arrayOf(PropTypes.string),
  initialPayload: PropTypes.object,
  translation: PropTypes.string,
  labelLegendMatchType: PropTypes.string,
  originField: PropTypes.string,
  type: PropTypes.string,
  isContextDependantFromAi: PropTypes.bool,
  isContextDependant: PropTypes.bool,
  isExported: PropTypes.bool,
  isCurationDone: PropTypes.bool,
  isQaDone: PropTypes.bool,
  correction: unknownWordCorrectionPropType,
  dish: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  menuTitle: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
  }),
  updatedBy: userDetailsPropType,
  updatedAt: PropTypes.string,
  createdBy: userDetailsPropType,
  createdAt: PropTypes.string,
  curatedBy: userDetailsPropType,
  curatedAt: PropTypes.string,
  qadBy: userDetailsPropType,
  qadAt: PropTypes.string,
})

export default unknownWordPropType
